import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import {
  DICTIONARY_ORGANIZATIONS_CITY_ADD,
  DICTIONARY_ORGANIZATIONS_POST_ADD,
  DICTIONARY_PORT_POST_ADD,
  DICTIONARY_VESSELS_POST_ADD,
} from "../axios";

export const axiosPostAddNewElementDictionary = async (
  axiosPrivate,
  apiUrl,
  bodyRequest,
  updateRequestDataDictionary,
  setActiveModalAddNewElementDictionary,
  setModalMessage
) => {
  try {
    const response = await axiosPrivate.post(
      apiUrl,
      JSON.stringify(bodyRequest)
    );
    console.log(response);
    setModalMessage(" ");
    setActiveModalAddNewElementDictionary(false);
    updateRequestDataDictionary();
  } catch (err) {
    setModalMessage("Error creating element dictionary, try later!");
    console.error(err);
  }
};

/**
 * Creates trigger function to post new element to dictionary
 * @param {import("axios").AxiosInstance} axios
 * @param {"port" | "vessel" | "organization" | "city"} type
 * @returns {(body : *) => Promise<void>}
 */

export function useAxiosPostDictionary(axios, type) {
  const { updateRequestDataDictionary } = useAuth();

  const url = (function chooseURL() {
    switch (type) {
      case "port":
        return DICTIONARY_PORT_POST_ADD;
      case "vessel":
        return DICTIONARY_VESSELS_POST_ADD;
      case "organization":
        return DICTIONARY_ORGANIZATIONS_POST_ADD;
      case "city":
        return DICTIONARY_ORGANIZATIONS_CITY_ADD;
      default:
        return undefined;
    }
  })();

  return (body) => axios.post(url, body).then(updateRequestDataDictionary);
}
